import { Skeleton } from "@/components/ui/skeleton";
import { usePaymentSetupStatus } from "@/features/payments/hooks/use-payment-setup-status";

import { PaymentAccount } from "./payment-account";
import { PaymentAccountEmpty } from "./payment-account-empty";

interface LatestPaymentProps {
  showChangeButton?: boolean;
  useTableStyle?: boolean;
}

export const LatestPayment = ({
  showChangeButton = true,
}: LatestPaymentProps) => {
  const { activePaymentAccount, hasCards, isLoading } = usePaymentSetupStatus();

  if (isLoading) {
    return (
      <Skeleton
        role="status"
        aria-label="Loading payment account"
        className="h-20 rounded-lg"
      />
    );
  }

  if (!activePaymentAccount) {
    // Neither an account nor a card means a redirect to payment setup is already
    // under way, so the prompt would only flash on the way out.
    return hasCards ? <PaymentAccountEmpty /> : null;
  }

  return (
    <PaymentAccount
      paymentAccount={activePaymentAccount}
      showChangeButton={showChangeButton}
    />
  );
};
